import React from 'react';
import { useTranslate } from '@agilepoint/wat-react';
import { StackPanel, useNotificationEvents } from '@agilepoint/wat-react-ux';
import { copyTextToClipboard } from '@agilepoint/utils-html';
import { getErrorMessage } from 'common/utils/error-message-utils';
import styled from 'styled-components';
import { ErrorInfo } from './api-error';
import { StyledPrimaryButton } from '../styled-components';

interface IErrorFallBackProps {
    error: any;
    resetErrorBoundary: any;
}

const ErrorFallbackWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

export function ReloadButton() {
    return (<StyledPrimaryButton onClick={() => window.location.reload()} label="Try Again" title='Reload' />);
}

export function ErrorFallback(props: IErrorFallBackProps) {
    const { error } = props;
    const errorMessage = getErrorMessage(error);
    const translate = useTranslate();
    const { showNotifications } = useNotificationEvents();

    const copyText = React.useCallback(() => {
        copyTextToClipboard(errorMessage);
        showNotifications({
            message: 'Error message copied to clipboard.'
        });
    }, [errorMessage, showNotifications]);

    return (
        <ErrorFallbackWrapper>
            <ErrorInfo errorObject={errorMessage} headerMessage={translate('common.messages.errorPageMessage')} />
            <StackPanel width='100%' height='100px' orientation='horizontal' justifyContent="center" gap="20" alignment="center">
                <ReloadButton />
                <StyledPrimaryButton onClick={copyText} label="Copy Error Log" title='Copy Error Log Message' />
            </StackPanel>
        </ErrorFallbackWrapper>
    );
}
